import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  userRoles: [],
  userRole: {
    policy: {
      Statements: []
    }
  },
  employeeListInRole: {
    role: {},
    employees: []
  },
  policySpecification: {
    PolicyGroups: [],
    PolicySpecs: {}
  }
}

export const mutations = {
  SET_USER_ROLES(state, userRoles) {
    state.userRoles = userRoles
  },
  SET_USER_ROLE(state, userRole) {
    state.userRole = userRole
  },
  SET_POLICY_SPECIFICATION(state, policySpecification) {
    state.policySpecification = policySpecification
  },
  SET_EMPLOYEE_LIST_IN_ROLE(state, employeeListInRole) {
    state.employeeListInRole = employeeListInRole
  },
  ADD_USER_ROLE(state, userRole) {
    state.userRoles.push(userRole)
  },
  EDIT_USER_ROLE(state, userRole) {
    const index = state.userRoles.findIndex(
      item => item.role_uuid === userRole.role_uuid
    )
    if (index !== -1) {
      state.userRoles.splice(index, 1, userRole)
    }
  },
  DELETE_USER_ROLE(state, userRoleUuid) {
    const index = state.userRoles.findIndex(
      item => item.role_uuid === userRoleUuid
    )
    if (index !== -1) state.userRoles.splice(index, 1)
  }
}

export const actions = {
  fetchUserRoles({ commit }, company_uuid) {
    return ApiService.fetchUserRoles(company_uuid)
      .then(response => {
        commit('SET_USER_ROLES', response.data.data)
      })
      .catch(error => {
        throw error
      })
  },
  fetchUserRole({ commit, getters, state }, role_uuid) {
    if (state.userRole.role_uuid === role_uuid) {
      return state.userRole
    }

    const userRole = getters.getUserRoleByUuid(role_uuid)

    if (userRole) {
      commit('SET_USER_ROLE', userRole)
    } else {
      return ApiService.fetchUserRole(role_uuid)
        .then(res => {
          const userRole = res.data
          commit('SET_USER_ROLE', userRole)
        })
        .catch(error => {
          throw error
        })
    }
  },
  fetchPolicySpecification({ commit }, payload) {
    return ApiService.fetchPolicySpecification(payload)
      .then(response => {
        commit('SET_POLICY_SPECIFICATION', response.data)
      })
      .catch(error => {
        throw error
      })
  },
  fetchEmployeeListInRole({ commit }, payload) {
    return ApiService.fetchEmployeeListInRole(payload)
      .then(response => {
        commit('SET_EMPLOYEE_LIST_IN_ROLE', response.data)
      })
      .catch(error => {
        throw error
      })
  },
  updateEmployeeListInRole({ commit }, payload) {
    return ApiService.updateEmployeeListInRole(payload)
      .then(response => {
        commit('SET_EMPLOYEE_LIST_IN_ROLE', response.data)
      })
      .catch(error => {
        throw error
      })
  },
  addUserRole({ commit }, payload) {
    return ApiService.addUserRole(payload)
      .then(response => {
        commit('ADD_USER_ROLE', response.data)
      })
      .catch(error => {
        throw error
      })
  },
  updateUserRole({ commit }, payload) {
    return ApiService.updateUserRole(payload)
      .then(response => {
        commit('EDIT_USER_ROLE', response.data)
      })
      .catch(error => {
        throw error
      })
  },
  deleteUserRole({ commit }, payload) {
    return ApiService.deleteUserRole(payload)
      .then(() => {
        commit('DELETE_USER_ROLE', payload.role_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}

export const getters = {
  getUserRoleByUuid: state => role_uuid => {
    return state.userRoles.find(item => item.role_uuid === role_uuid)
  }
}
